import React, { useState } from "react";
import * as Components from "../../../components/all";
import { useNavigate } from "react-router-dom";
import { AiFillEye } from "react-icons/ai";
import { HiOfficeBuilding } from "react-icons/hi";

export default function Users() {
	const navigate = useNavigate();
	// eslint-disable-next-line no-unused-vars
	const [loading, setLoading] = useState(false);

	// Users Data
	var usersData = {
		totalPS: 698,
		allPS: [
			{
				id: 1,
				name: "Comsats University Islamabad",
				city: "Islamabad",
			},
			{
				id: 2,
				name: "University Islamabad",
				city: "Islamabad",
			},
			{
				id: 3,
				name: "Islamabad",
				city: "Islamabad",
			},
			{
				id: 4,
				name: "Comsats University Islamabad",
				city: "Islamabad",
			},
			{
				id: 5,
				name: "University Islamabad",
				city: "Islamabad",
			},
			{
				id: 6,
				name: "Islamabad",
				city: "Islamabad",
			},
			{
				id: 7,
				name: "Comsats University Islamabad",
				city: "Islamabad",
			},
			{
				id: 8,
				name: "University Islamabad",
				city: "Islamabad",
			},
			{
				id: 9,
				name: "Islamabad",
				city: "Islamabad",
			},
		],
	};

	// Search Feature
	const [usersFilter, setUsersFilter] = useState(false);
	const [filterType, setFilterType] = useState("name");
	const [filteredUsers, setFilteredUsers] = useState(usersData.allPS);
	const search = (term) => {
		if (term === "") {
			setFilteredUsers(usersData.allPS);
			return;
		}

		const filtered = usersData.allPS.filter(
			(x) =>
				(filterType === "name" ? x.name : x.city)
					.toLowerCase()
					.indexOf(term.toLowerCase()) > -1
		);
		setFilteredUsers(filtered);
	};

	return loading === true ? (
		<Components.Loader />
	) : (
		<div
			className="ParkingSpaces
            overflow-x-hidden overflow-y-auto 
            h-full 
            w-full
            sm:p-3 md:p-5
            flex flex-row flex-wrap
            "
		>
			{/* TOP CARDS ROW */}
			<div
				className="TOP-CARDS 
				flex flex-col 
			    sm:flex-1
				overflow-hidden
				sm:min-w-[500px] 
				max-sm:w-full
			"
			>
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
					min-h-[120px] 
					sm:min-w-[300px] flex-1                    rounded-md
                    p-5 m-2
                    bg-white 
                    flex flex-col
                    "
				>
					<div className="flex items-center justify-between flex-1">
						<div className="flex flex-col justify-between h-full">
							<div className="flex items-center">
								<div
									className="
                                h-6 w-6 
                                flex items-center justify-center
                                rounded-full
                                bg-[#DBF6ED] 
                                text-[#8DBEAD]
                                "
								>
									<HiOfficeBuilding />
								</div>

								<h1 className="ml-2 text-darker">Total Parking Spaces</h1>
							</div>

							<h1 className="text-3xl font-medium tracking-tighter">
								{usersData.totalPS.toLocaleString()}
							</h1>
						</div>

						<button
							className="bg-main text-white 
                            px-4 py-1 
                            text-sm rounded-md 
                            font-medium 
                            max-sm:w-[150px]
                            max-sm:mt-auto
                            duration-300 ease-in-out
                            hover:opacity-70
                            "
							onClick={() => navigate("newps")}
						>
							+ Create New Parking Space
						</button>
					</div>
				</div>

				{/* card 2 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
                    min-h-[380px] sm:min-h-[480px] h-full 
                    p-5 m-2
                    rounded-md
                    bg-white 
                    flex flex-col
                    overflow-auto
                    "
				>
					{/* heading */}
					<div className="p-2 py-0 w-full">
						<div className="flex items-center justify-between">
							<h1 className="text-xl">Search Parking Space</h1>
						</div>
					</div>

					{/* filters */}
					<div className="w-full">
						{/* selection */}
						<div className="w-full flex p-2 pt-0 justify-end">
							<button
								className={`
							text-sm 
							px-3 py-1 mx-1
							rounded-full
							flex items-center
							duration-200 ease-in-out
							${usersFilter === true ? "bg-main text-white" : "bg-bg text-dark"}
							`}
								onClick={() => setUsersFilter(true)}
							>
								Filters
							</button>

							<button
								className={`
							text-sm 
							px-3 py-1 mx-1
							rounded-full
							duration-200 ease-in-out
							${usersFilter === false ? "bg-main text-white" : "bg-bg text-dark"}
							`}
								onClick={() => setUsersFilter(false)}
							>
								All
							</button>
						</div>
					</div>

					{/* search */}
					<div
						className={`
						mb-4 mt-2 p-1 bg-gray-50 rounded
						${usersFilter === true ? " flex" : "hidden"}
						`}
					>
						<div className="relative flex-1">
							<div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
								<svg
									className="w-5 h-5 text-gray-500"
									aria-hidden="true"
									fill="currentColor"
									viewBox="0 0 20 20"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fillRule="evenodd"
										d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
										clipRule="evenodd"
									></path>
								</svg>
							</div>
							<input
								type="text"
								className="w-full block p-1.5 pl-10 text-sm text-gray-900  border-gray-300 rounded bg-gray-50 focus:outline-none"
								placeholder="Search for parking spaces"
								onChange={(e) => search(e.target.value)}
							/>
						</div>

						<div className="flex items-center justify-end">
							<button
								className={`
							text-xs 
							px-3 py-1 mx-1
							rounded-full
							flex items-center
							duration-200 ease-in-out
							${filterType === "name" ? "bg-main text-white" : "bg-bg text-dark"}
							`}
								onClick={() => setFilterType("name")}
							>
								Name
							</button>

							<button
								className={`
							text-xs 
							px-3 py-1 mx-1
							rounded-full
							duration-200 ease-in-out
							${filterType === "city" ? "bg-main text-white" : "bg-bg text-dark"}
							`}
								onClick={() => setFilterType("city")}
							>
								City
							</button>
						</div>
					</div>

					{/* data */}
					<div className="max-h-[calc(100vh)] 2xl:max-h-[calc(100vh-220px)] flex-1 overflow-y-auto">
						{/* table */}
						<div className="h-fit w-full overflow-y-hidden overflow-x-auto shadow-md sm:rounded">
							<div className="overflow-hidden min-w-max">
								<table className="w-full text-sm text-left text-gray-500">
									<thead className="text-xs text-gray-700 uppercase bg-gray-50">
										<tr>
											<th scope="col" className="px-6 py-3">
												Name
											</th>
											<th scope="col" className="px-6 py-3">
												City
											</th>
											<th scope="col" className="px-3 py-3">
												Details
											</th>
										</tr>
									</thead>

									<tbody className="">
										{(usersFilter === false
											? usersData.allPS
											: filteredUsers
										).map(({ id, name, city }, index) => (
											<tr
												key={index}
												className="bg-white border-b hover:bg-gray-50"
											>
												<th
													scope="row"
													className="px-6 py-4 font-medium text-darker whitespace-nowrap"
												>
													{name}
												</th>

												<td className="px-6 py-4">{city}</td>

												<td className="py-4">
													<p
														className="text-blue-400 hover:underline flex items-center w-fit
														cursor-pointer
														pl-6
														"
														onClick={() => navigate(`ps/${id}`)}
													>
														<AiFillEye size={20} />
													</p>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
